import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=de48b9d8&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de48b9d8",
  null
  
)

export default component.exports